import React from 'react';
import { getStatusColor } from '../../utils/helpers';

const Badge = ({ children, variant = 'default', className = '' }) => {
  const baseStyles = 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium';
  
  // Use helper if variant matches a status, otherwise fallback
  // Ensure children is a string before passing to getStatusColor
  const statusString = typeof children === 'string' ? children : String(children || '');
  const colorClass = getStatusColor(statusString) || 'bg-gray-100 text-gray-800';

  return (
    <span className={`${baseStyles} ${colorClass} ${className}`}>
      {children}
    </span>
  );
};

export default Badge;
